import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CmsItem } from '@coin/shared/cms/util';
import { V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { PureFunctionPipe } from '@coin/shared/core/util-pipes';
import { TranslateModule } from '@ngx-translate/core';
import { HtmlEditorComponent } from '../../shared/html-editor/html-editor.component';

@Component({
  selector: 'coin-equity-expand-box',
  templateUrl: './equity-expand-box.component.html',
  styleUrls: ['./equity-expand-box.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    FormsModule,
    TranslateModule,
    NgClass,
    HtmlEditorComponent,
    V2TextInputComponent,
    PureFunctionPipe
  ]
})
export class EquityExpandBoxComponent {
  @Input() item: CmsItem<'expand-box'>;
  @Input() contentEdit = false;

  public boxExpanded = false;

  public cutOutNbsp(text: string): string {
    return text?.replaceAll(/&nbsp;(?!<)|(?<!>)&nbsp;/g, ' ');
  }
}
